import React from 'react';
import { useTranslation } from 'react-i18next';
import TimePicker from '../../components/TimePicker';
import type { SchemaFieldProps } from '../types';

/**
 * Custom SchemaForm widget wrapping the shared TimePicker for an event
 * template's `startTime` / `endTime` (stored as 'HH:MM' strings). Used as an
 * override for both fields so the date/time UX stays identical to the legacy
 * EventTemplateForm. The visible label is chosen from the field name to keep
 * the existing "Start time" / "End time" wording rather than the shared
 * `templates.time` meta label.
 */
const TimePickerField: React.FC<SchemaFieldProps> = ({ field, value, onChange, error }) => {
  const { t } = useTranslation();
  const labelKey = field.name === 'endTime' ? 'events.endTime' : 'events.startTime';

  return (
    <div className="form-group form-group-half">
      <TimePicker
        id={`sf-${field.name}`}
        label={t(labelKey)}
        value={value ?? ''}
        onChange={onChange}
        required={field.required}
        error={error}
      />
    </div>
  );
};

export default TimePickerField;
